// Stonehush quest hint locations (world XZ). Villager posts match TownNPCs pins.
export const STONEHUSH_TOWN_CENTER = { x: -830, z: -5000 };

export const STONEHUSH_VILLAGER_POSTS = [
  { x: -816, z: -4994 },
  { x: -844, z: -5002 },
  { x: -826, z: -5010 },
  { x: -836, z: -4988 },
];
